<template>
  <v-text-field
    :rules="textFieldErrors()"
    type="text"
    :value="value"
    v-on:input="$emit('input', $event)"
    :model="value"
    :label="label"
    :mask="mask"
    :placeholder="placeholder"
    :disabled="disabled"
    :color="'#00BFB3'"
    :height="'44'"
    :persistent-hint="true"
    :background-color="'#EFEFEF'"
  ></v-text-field>
</template>

<script>
import Vue from "vue";
import Moment from "moment-timezone";

export default {
  name: "edit-text",
  methods: {
    textFieldErrors(){
      if (this.value.length == 0) {
        return ["Campo obrigatório"]
      }

      if (this.rule) {
        if (this.rule == "date") {
          var date = Moment(this.value, "DDMMYYYY")
          return date.isValid() && date.isBefore() ? [true] : ["Informe uma data válida"]
        }
      }
      return [true]
    }
  },
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    mask: {
      type: String,
      default: null
    },
    rule: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    isHidden: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    }
  }
};
</script>

<style lang="scss">
@media (max-width: 991px) {
  #edit-text {
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
.v-text-field .v-label--active {
  margin-left: 0px;
  padding-left: 0px;
  transform: translateY(-28px) translateX(0px) scale(0.75);
}
label {
  padding-left: 10px;
  padding-right: 10px;
}
.v-text-field input {
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/fields/EditText.vue